/** Derives `headerTooltip` from `headerName` so hovering a column header always shows its full label — AG Grid doesn't do this automatically. */
export function withHeaderTooltip<T extends { headerName?: string; headerTooltip?: string }>(colDef: T): T {
  return colDef.headerTooltip || !colDef.headerName ? colDef : { ...colDef, headerTooltip: colDef.headerName };
}
